"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTradeResourceNum = exports.getSpecialCount = exports.getResourceNum = exports.getRandomList100 = exports.getPositionList = exports.getPageNumList = exports.getCourseNum = exports.getBannerList = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
// 获取轮播图集合
var getBannerList = exports.getBannerList = function getBannerList(params) {
  return _api.default.request({
    url: '/system/web/admin/banner/list?pageNum=1&pageSize=10',
    method: 'get',
    params: params
  });
};
// 获取对应类型课程数量
// 参数：type  1专业与课程服务中心、2虚拟仿真实训中心、3教师能力提升中心、4教材资源中心、5首都特色教育
var getCourseNum = exports.getCourseNum = function getCourseNum(params) {
  return _api.default.request({
    url: '/system/homePage/getCourseNum',
    method: 'get',
    params: params
  });
};
// 你从事什么职业呢
var getPositionList = exports.getPositionList = function getPositionList(params) {
  return _api.default.request({
    url: '/system/position/list',
    method: 'get',
    params: params
  });
};
// 行业分类资源数量
var getTradeResourceNum = exports.getTradeResourceNum = function getTradeResourceNum(params) {
  return _api.default.request({
    url: '/system/homePage/getTradeResourceNum',
    method: 'get',
    params: params
  });
};
// 想学习的专业来这里
var getPageNumList = exports.getPageNumList = function getPageNumList(params) {
  return _api.default.request({
    url: '/system/major/classes/list?pageNum=1&pageSize=10000&parentId=0',
    method: 'get',
    params: params
  });
};
// 获取知识点列表
var getRandomList100 = exports.getRandomList100 = function getRandomList100(params) {
  return _api.default.request({
    url: '/teacher/courseInfoKnowledgePoints/randomList100',
    headers: {
      isToken: false
    },
    method: 'get',
    params: params
  });
};
// 获取资源数量
var getResourceNum = exports.getResourceNum = function getResourceNum(params) {
  return _api.default.request({
    url: '/system/homePage/getResourceNum',
    method: 'get',
    params: params
  });
};

// 获取首页专题数量
var getSpecialCount = exports.getSpecialCount = function getSpecialCount(data) {
  return _api.default.request({
    url: '/system/web/peCourse/getCourseTypeCount',
    method: 'post',
    data: data
  });
};